// Empleados y eventos (réplica de backend/empleados_eventos.py).
//
// - Coste en eventos (`coste_personal_evento`): 'tarifa' (tarifa del equipo
//   propio) o 'sin_coste' (los socios). Sin valor guardado, por el rol:
//   'direccion' sin coste y el resto con tarifa.
// - Cuenta técnica (`es_cuenta_tecnica`): cuentas solo para entrar en el ERP
//   (p. ej. "admin"); no salen en las listas de personal de eventos. Sin valor
//   guardado, lo es el empleado cuyo nombre es "admin".
// - No va a eventos (`no_va_a_eventos`): persona real que no va a eventos
//   (personal de nave). Solo sale de las listas de personal de eventos; la
//   cuenta técnica sale de todo (nóminas, obligaciones...).

export const COSTE_TARIFA = 'tarifa';
export const COSTE_SIN_COSTE = 'sin_coste';

const texto = (v) => String(v || '').trim().toLowerCase();

export const costePersonalEventoPorDefecto = (rol) => (texto(rol) === 'direccion' ? COSTE_SIN_COSTE : COSTE_TARIFA);

export const costePersonalEvento = (emp) => {
  const valor = emp?.coste_personal_evento;
  if (valor === COSTE_TARIFA || valor === COSTE_SIN_COSTE) return valor;
  return costePersonalEventoPorDefecto(emp?.rol);
};

export const sinCosteEvento = (emp) => !!emp && costePersonalEvento(emp) === COSTE_SIN_COSTE;

export const esCuentaTecnicaPorDefecto = (nombre) => texto(nombre) === 'admin';

export const esCuentaTecnica = (emp) => {
  if (typeof emp?.es_cuenta_tecnica === 'boolean') return emp.es_cuenta_tecnica;
  return esCuentaTecnicaPorDefecto(emp?.nombre);
};

export const noVaAEventos = (emp) => emp?.no_va_a_eventos === true;

export const esPersonaEventos = (emp) => !!emp && !esCuentaTecnica(emp) && !noVaAEventos(emp);
